import { render } from "./ControlCrud.vue?vue&type=template&id=83c2bca4&scoped=true"
import script from "./ControlCrud.vue?vue&type=script&lang=js"
export * from "./ControlCrud.vue?vue&type=script&lang=js"

import "./ControlCrud.vue?vue&type=style&index=0&id=83c2bca4&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83c2bca4"]])

export default __exports__